module.exports = __webpack_public_path__ + "static/media/wavm8s-018-ware-2018-edition.9025ac3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-018-ware-2018-edition.mp3
// module id = AFXY
// module chunks = 0